import { useMutation, useQueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { postNewPlan } from 'api/InteractiveMap/postNewPlan';

const usePostNewPlan = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const {
    isSuccess,
    mutate: createNewPlan,
    isLoading,
  } = useMutation(postNewPlan, {
    onSuccess: () => {
      queryClient.invalidateQueries('plans');
      // enqueueSnackbar('Plan was created successfully', { variant: 'success' });
    },
    onError: (error: any) => {
      if (error.response?.status === 413 || error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        enqueueSnackbar(t('AddSiteMap.tooLargeFile'), { variant: 'error' });
      } else if (error.response?.status === 400) {
        enqueueSnackbar(t('AddSiteMap.validationError', 'Check your input'), { variant: 'error' });
      } else {
        enqueueSnackbar(t('AddSiteMap.serverError', 'Something went wrong, please try again later'), {
          variant: 'error',
        });
      }
    },
  });

  return {
    isSuccess,
    createNewPlan,
    isLoading,
  };
};

export default usePostNewPlan;
